import React from 'react'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import Loader from '../generic/Loader'

const ProductsList = inject('productsStore', 'uiStore')(observer(props => {
  const { productsStore, uiStore } = props
  const { products, isFetching } = productsStore.state
  const { activeItem } = uiStore.state.sidebar
  return (
    <Loader isLoading={isFetching}>
      {products.map(product => {
        const productName = product.name
        const isActive = activeItem === productName ? 'is-active' : ''
        return (
          <li key={productName}>
            <Link to={`/dashboard/produtos/${productName}`} className={isActive} onClick={() => productsStore.changeActiveProduct(productName, uiStore)}>
              {productName}
            </Link>
          </li>
        )
      })}
    </Loader>
  )
}))

export default ProductsList



// WEBPACK FOOTER //
// ./src/components/dashboard/ProductsList.js